import ReactDOM from 'react-dom';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from 'dayjs';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
// import { ReactQueryDevtools } from 'react-query/devtools';
import { ChakraProvider } from '@chakra-ui/react';
import { ErrorHandler } from '@Components/errorHandler';
import { store, persistor } from './store';
import 'regenerator-runtime/runtime';
import './i18n';
import AppRoute from './routes/app';
import PageLoading from './components/pageLoading';
import { QueryClientProvider } from './queryClient';

import theme from './theme';

// dayjs extend plugin
dayjs.extend(utc);
dayjs.extend(timezone);

// 當執行的時候，會把 AppRoute 的 Component，render 到 root 這個 DOM 節點上面去
ReactDOM.render(
  <QueryClientProvider>
    <Provider store={store}>
      <PersistGate loading={<PageLoading maskAll />} persistor={persistor}>
        <ChakraProvider resetCSS={false} theme={theme}>
          <ErrorHandler>
            <AppRoute />
          </ErrorHandler>
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </ChakraProvider>
      </PersistGate>
    </Provider>
  </QueryClientProvider>,
  document.getElementById('root'),
);
